import React from 'react'
import { Modal } from '@taglivros/oef_componentes'
import { bool, func, string } from 'prop-types'
import Button from '@taglivros/oef_componentes/build/components/button'
import { ModalWrapper, Container, SpanColor } from './style'
import SvgRowText from '../Renovacao/SvgRowText'
import styled from 'styled-components'
import { ReactComponent as Repeat } from '../../../../assets/icons/repeat.svg'

const Support = styled.div`
  margin-top: 20px;
  font-size: 14px;
  background: #f9f9f9;
  padding: 10px;
  border-radius: 10px;
  color: #808080;
  line-height: 20px;
  .bold {
    font-weight: 600;
  }
`

const DesativarRenovaoModal = ( { open, onShowModal, isCuradoria, plan } ) => {
  return (
    <ModalWrapper
      height="90%"
      open={ open }
    >
      <Modal
        altura="auto"
        onShowModal={ onShowModal }
        show={ open }
      >
        <Container isCuradoria={ isCuradoria }>
          <div className="overflow">
            <div className="blue-div">
              <div className="center">
                <Repeat />
              </div>

              <span>
                {`Assinatura com renovação automática ${plan.toLowerCase()}`}
              </span>
            </div>

            <div className="colored-text">
              <span className="grey-color">A</span>

              <SpanColor isCuradoria={ isCuradoria }>
                {' '}

                renovação automática{' '}
              </SpanColor>

              <span className="grey-color">
                é uma forma de trazer mais comodidade para o seu dia a dia pois
                você não precisará se preocupar com a renovação do seu plano,{' '}
              </span>

              <SpanColor isCuradoria={ isCuradoria }>
                nós faremos isso para você.
              </SpanColor>

              <div style={{ 'paddingTop': '20px' }} />

              <span className="grey-color">
                A próxima cobrança será feita apenas no final da sua assinatura
                atual.
              </span>
            </div>

            <SvgRowText plan={ plan } />

            <Support>
              <span>
                Ficou com alguma outra dúvida? Entre em contato com a gente:
              </span>

              <span className="bold">{` contato@taglivros.com.br`}</span>
            </Support>
          </div>

          <div className="buttons-100">
            <Button
              invertido
              onClick={ onShowModal }
              tema={
                isCuradoria ? Button.BOTAO_CURADORIA : Button.BOTAO_INEDITOS
              }
              type={ Button.TYPE_SUBMIT }
            >
              Entendi
            </Button>
          </div>
        </Container>
      </Modal>
    </ModalWrapper>
  )
}

DesativarRenovaoModal.propTypes = {
  'isCuradoria': bool.isRequired,
  'loading': bool,
  'onOkButton': func,
  'onShowModal': func.isRequired,
  'open': bool.isRequired,
  'plan': string.isRequired
}

DesativarRenovaoModal.defaultProps = {
  'onOkButton': () => null,
  'loading': false,
}

export default DesativarRenovaoModal
